/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Permissions disponibles pour la contractualisation emprunteur.
 * @export
 * @interface BorrowerPermissions
 */
export interface BorrowerPermissions {
    /**
     * Peut modifier les informations de l'emprunteur.
     * @type {boolean}
     * @memberof BorrowerPermissions
     */
    canEditInsured: boolean;
    /**
     * Peut modifier le risque/projet.
     * @type {boolean}
     * @memberof BorrowerPermissions
     */
    canEditRisk: boolean;
    /**
     * Peut modifier les prêts (verrouillé dès qu'un emprunteur du projet a envoyé sa demande).
     * @type {boolean}
     * @memberof BorrowerPermissions
     */
    canEditLoan: boolean;
    /**
     * Peut envoyer le questionnaire santé.
     * @type {boolean}
     * @memberof BorrowerPermissions
     */
    canSendMedicalSurvey: boolean;
    /**
     * Peut envoyer le bon pour accord.
     * @type {boolean}
     * @memberof BorrowerPermissions
     */
    canSendApprovedAgreement: boolean;
    /**
     * Peut envoyer la demande d'adhésion (DIA).
     * @type {boolean}
     * @memberof BorrowerPermissions
     */
    canSendSubscriptionRequest: boolean;
    /**
     * Peut récupérer le certificat d'adhésion (CIA).
     * @type {boolean}
     * @memberof BorrowerPermissions
     */
    canGetCertificate: boolean;
    /**
     * Peut envoyer la fiche médicale complémentaire (formalités médicales).
     * @type {boolean}
     * @memberof BorrowerPermissions
     */
    canSendMedicalForm?: boolean;
}

/**
 * Check if a given object implements the BorrowerPermissions interface.
 */
export function instanceOfBorrowerPermissions(value: object): value is BorrowerPermissions {
    if (!('canEditInsured' in value) || value['canEditInsured'] === undefined) return false;
    if (!('canEditRisk' in value) || value['canEditRisk'] === undefined) return false;
    if (!('canEditLoan' in value) || value['canEditLoan'] === undefined) return false;
    if (!('canSendMedicalSurvey' in value) || value['canSendMedicalSurvey'] === undefined) return false;
    if (!('canSendApprovedAgreement' in value) || value['canSendApprovedAgreement'] === undefined) return false;
    if (!('canSendSubscriptionRequest' in value) || value['canSendSubscriptionRequest'] === undefined) return false;
    if (!('canGetCertificate' in value) || value['canGetCertificate'] === undefined) return false;
    return true;
}

export function BorrowerPermissionsFromJSON(json: any): BorrowerPermissions {
    return BorrowerPermissionsFromJSONTyped(json, false);
}

export function BorrowerPermissionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerPermissions {
    if (json == null) {
        return json;
    }
    return {
        
        'canEditInsured': json['canEditInsured'],
        'canEditRisk': json['canEditRisk'],
        'canEditLoan': json['canEditLoan'],
        'canSendMedicalSurvey': json['canSendMedicalSurvey'],
        'canSendApprovedAgreement': json['canSendApprovedAgreement'],
        'canSendSubscriptionRequest': json['canSendSubscriptionRequest'],
        'canGetCertificate': json['canGetCertificate'],
        'canSendMedicalForm': json['canSendMedicalForm'] == null ? undefined : json['canSendMedicalForm'],
    };
}

export function BorrowerPermissionsToJSON(json: any): BorrowerPermissions {
    return BorrowerPermissionsToJSONTyped(json, false);
}

export function BorrowerPermissionsToJSONTyped(value?: BorrowerPermissions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'canEditInsured': value['canEditInsured'],
        'canEditRisk': value['canEditRisk'],
        'canEditLoan': value['canEditLoan'],
        'canSendMedicalSurvey': value['canSendMedicalSurvey'],
        'canSendApprovedAgreement': value['canSendApprovedAgreement'],
        'canSendSubscriptionRequest': value['canSendSubscriptionRequest'],
        'canGetCertificate': value['canGetCertificate'],
        'canSendMedicalForm': value['canSendMedicalForm'],
    };
}

